import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AmountUtils, cn, ColorUtils, DateUtils } from '@shared/utils';
import type { PaymentsByRecipientIdResponse } from '@shared/api';
import { Table, TableCellType } from '@shared/widgets';

interface ITableProps {
  isLoading?: boolean;
  error?: string | null;
  onRefresh?: () => void;
  data?: PaymentsByRecipientIdResponse[];
  currentPage: number;
  totalItemCount: number;
  countItemPage: number;
  onChangePage: (pageNumber: number) => void;
  onChangeCountItemPage: (pageNumber: number) => void;
}

export const RecipientTable = (props: ITableProps) => {
  const { t } = useTranslation('recipient');

  const columns = useMemo(
    () => [
      t('transaction.columns.status'),
      t('transaction.columns.date'),
      t('transaction.columns.transactionReference'),
      t('transaction.columns.totalAmount'),
      t('transaction.columns.amount'),
      t('transaction.columns.direction'),
    ],
    [t],
  );
  return (
    <Table
      isScrollable
      isLoading={props.isLoading}
      error={props.error}
      onRefresh={props.onRefresh}
      columns={columns}
      items={
        props.data?.map((row) => {
          const color = ColorUtils.getDepositPaymentStatusStyles(row.paymentStatus);
          return [
            {
              type: TableCellType.Custom,
              value: (
                <div className={cn('whitespace-nowrap bg-opacity-10 px-2 py-1 text-center font-normal', color.bg, color.text)}>
                  {t(`statuses.paymentTransaction.${row.paymentStatus}`, { ns: 'common' })}
                </div>
              ),
            },
            { type: TableCellType.Text, value: DateUtils.formatDate(row.createdDate) },
            { type: TableCellType.Text, value: row.description || '-' },
            { type: TableCellType.Text, value: AmountUtils.transformToAmountWithCurrency(row.totalAmount, row.currency) },
            { type: TableCellType.Text, value: AmountUtils.transformToAmountWithCurrency(row.amount, row.currency) },
            { type: TableCellType.Text, value: t(`direction.${row.paymentDirection.toLowerCase()}`, { ns: 'common' }) },
          ];
        }) || []
      }
      pagination={{
        currentPage: props.currentPage,
        totalItemCount: props.totalItemCount,
        countItemPage: props.countItemPage,
        onChangePage: props.onChangePage,
        onChangeCountItemPage: props.onChangeCountItemPage,
      }}
    />
  );
};
